// Connects the Edit patient info modal component with store
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SecureLink from '../../components/modal/SecureLink';
import { getRecordLink } from '../../actions/records';
import { captureAnalytics } from '../../actions/preload';
import { secureLinkDenied } from '../../util/inboxRowCapabilities';

class SecureLinkDialog extends Component {

  componentDidMount() {
    const { modalType: { data: { fileToken: recordId } }, getRecordLink: getLink } = this.props;
    const { receiverType } = this.props.modalType.data;
    if (this.linkUnavailable()) return;
    if (receiverType === 'reply') captureAnalytics('reply_document_secure_link_requested', { surface: 'viewer' });
    getLink(recordId);
  }

  // Ordinary callers pass no receiverType.
  linkUnavailable = () => secureLinkDenied(this.props.modalType.data);

  render() {
    const denied = this.linkUnavailable();
    return (
      <div>
        <SecureLink
          {...this.props}
          secureLink={denied ? '' : this.props.secureLink}
          isLoading={denied ? false : this.props.isLoading}
          error={denied || this.props.error}
          errorMessage={denied ? 'Secure link creation is unavailable for this document.' : this.props.errorMessage}
        />
      </div>
    );
  }
}

SecureLinkDialog.defaultProps = {
  isLoading: false,
  error: false,
  secureLink: '',
  errorMessage: '',
};

SecureLinkDialog.propTypes = {
  getRecordLink: PropTypes.func.isRequired,
  secureLink: PropTypes.string,
  errorMessage: PropTypes.string,
  isLoading: PropTypes.bool,
  error: PropTypes.bool,
  modalType: PropTypes.shape({
    data: PropTypes.shape({
      fileToken: PropTypes.string,
      receiverType: PropTypes.string,
      canCreateSecureLink: PropTypes.bool,
      replyDocumentState: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default connect(state => ({
  secureLink: state.records.secure_link,
  isLoading: state.records.isLoading,
  error: state.records.error,
  errorMessage: state.records.errorMessage,
  records: state.records,
}), { getRecordLink })(SecureLinkDialog);
